<template>
  <div class="container-fluid">
    <div class="row g-0">
      <div class="col-8">
        <vue-good-table
          class="vue-table"
          ref="table"
          :columns="columns"
          :rows="typesenseStore.packageList"
          styleClass="vgt-table condensed bordered"
          @row-click="typesenseStore.fetchCurrent"
          @page-change="onPageChange"
          @sort-change="onSortChange"
          @per-page-change="onPerPageChange"
          :isLoading.sync="isLoading"
          :pagination-options="paginationOptions"
          :totalRows="typesenseStore.totalRecords"
          ><template #table-actions-bottom>
            <pagination-records
              :pages="serverParams.page"
              :per-page="serverParams.per_page"
              :total="typesenseStore.totalRecords"
          /></template>
          <template #table-row="props">
            <!-- <span v-if="props.column.field == 'checkbox'">
              <span v-if="props.row.checkboxDisabled">
                <input type="checkbox" style="margin: 10px" :disabled="true" />
              </span>
              <span v-else>
                <input
                  type="checkbox"
                  id="props.row.id"
                  :value="props.row.transferBatchNo"
                  style="margin: 10px"
                  @change="selectionChanged(props.row.transferBatchNo)"
                />
              </span>
            </span> -->
            <span v-if="props.column.field == 'after'">
              <button
                class="btn btn-success"
                style="width: 80px; margin-right: 6px"
                data-bs-toggle="modal"
                data-bs-target="#approveRequestModal"
                :disabled="props.row.status != 'Pending'"
              >
                Approve
              </button>
              <button
                class="btn btn-danger"
                style="width: 80px"
                data-bs-toggle="modal"
                data-bs-target="#rejectRequestModal"
                :disabled="props.row.status != 'Pending'"
              >
                Reject
              </button>
            </span>
            <span v-if="props.row.uuid == typesenseStore.currentContent?.uuid">
              <span style="font-weight: bold; color: blue">{{
                props.formattedRow[props.column.field]
              }}</span></span
            >
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
      <div class="col-4">
        <reviewer-details class="request-details" />
      </div>
    </div>
  </div>
  <manage-request-modal
    :selected-id="typesenseStore.currentContent?.uuid"
    :server-params="serverParams"
  />
</template>

<script setup lang="ts">
import ManageRequestModal from "@/components/Modal/ManageRequestModal.vue";
import PaginationRecords from "@/components/Pagination/PaginationRecords.vue";
import ReviewerDetails from "@/components/RequesterReviewer/ReviewerDetails.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useDownloadStore } from "@/stores/download";
import { useTypesenseStore } from "@/stores/typesense";
import { useAsyncState } from "@vueuse/core";
import { ref, provide, watch } from "vue";

const table = ref();
const downloadStore = useDownloadStore();
const authStore = useAuthenticationStore();
const typesenseStore = useTypesenseStore();
const TypesenseKey = ref();
const type = ref("secure-zone-downloads");
const isLoading = ref(false);

watch(
  () => downloadStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

watch(
  () => typesenseStore.loading,
  (updateLoading) => {
    isLoading.value = updateLoading;
  }
);

const columns = [
  // {
  //   label: "",
  //   sortable: false,
  //   field: "checkbox",
  //   width: "40px",
  // },
  {
    label: "AIP/DIP",
    field: "package_type",
    sortable: false,
  },
  {
    label: "Package UUID",
    field: "package_uuid",
    sortable: false,
  },
  {
    label: "Request UUID",
    field: "uuid",
    sortable: false,
  },
  {
    label: "Transfer Batch No.",
    field: "transfer_batch",
  },
  {
    label: "Requested Type",
    field: "type",
    sortable: false,
  },
  {
    label: "Request Status",
    field: "status",
    sortable: false,
  },
  {
    label: "",
    field: "after",
    sortable: false,
    width: "180px",
  },
];
// const checkedData: any = ref([]);
// const buttonDisabled = ref(true);

// const selectionChanged = (params) => {
//   if (!checkedData.value.includes(params)) {
//     checkedData.value.push(params);
//   } else {
//     for (let i = 0; i < checkedData.value.length; i++) {
//       if (checkedData.value[i] == params) {
//         checkedData.value.splice(i, 1);
//       }
//     }
//   }
//   console.log("array: ", checkedData.value);
//   buttonDisabled.value = !checkedData.value.length;
// };

provide("selectedRowData", typesenseStore.currentContent);
provide("data", typesenseStore.packageList);

const paginationOptions = ref({
  enabled: true,
  mode: "pages",
  position: "bottom",
  perPage: 20,
  perPageDropdown: [10, 20, 30],
  dropdownAllowAll: false,
});

const serverParams = ref({
  filter_by: "requester:!=" + authStore.profile_email + " && type:=PD",
  sort_by: "",
  q: "*",
  query_by: "",
  page: 1,
  per_page: paginationOptions.value.perPageDropdown[1],
});

const updateParams = (newProps: any) => {
  serverParams.value = Object.assign({}, serverParams.value, newProps);
};

const onPageChange = (params) => {
  updateParams({ page: params.currentPage });
  execute();
};

const onPerPageChange = (params) => {
  updateParams({ per_page: params.currentPerPage, page: 1 });
  execute();
};

const onSortChange = (params) => {
  if (params[0].type === "none") {
    updateParams({
      sort_by: "",
    });
  } else {
    updateParams({
      sort_by: params[0].field + ":" + params[0].type,
    });
  }
  execute();
};

const { execute, error } = useAsyncState(() => {
  return typesenseStore.fetchTypesense(type.value, serverParams.value);
}, null);
</script>

<style scoped>
.container-fluid {
  padding: 0;
}
.vue-table {
  position: relative;
  left: 0;
  margin: 0;
  width: 100%;
  padding: 10px;
  padding-top: 16px;
  overflow: auto;
}
.request-details {
  width: 100%;
  height: 100%;
  position: fixed;
  overflow: auto;
}
</style>
